// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2-HsO","title":"FrontImage_title__2hklz"};